import { render, staticRenderFns } from "./quilombola.vue?vue&type=template&id=76aabd1d"
import script from "./quilombola.vue?vue&type=script&lang=js"
export * from "./quilombola.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports